import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { API } from '@service';

function useIntegrationModuleFinder(projectId, integrationModuleId) {
  const integrationModuleDataInStore = useSelector(
    ({ projects }) => projects?.projectDetail?.originIntegrationData,
  );
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async (projectId) => {
    setLoading(true);
    try {
      const res = await API.getIntergrationOverview(projectId);
      if (res) {
        setData(res);
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  }, []);

  const targetModule = useMemo(() => {
    if (!data) {
      return {};
    }
    for (const tab in data.integrationModuleWithTabList) {
      const tabData = data.integrationModuleWithTabList[tab];
      for (const module in tabData.moduleList) {
        const tileModule = tabData.moduleList[module];
        if (tileModule?.moduleId === integrationModuleId) {
          return tileModule;
        }
      }
    }
  }, [data, integrationModuleId]);

  useEffect(() => {
    if (!(projectId && integrationModuleId)) {
      return;
    }
    if (integrationModuleDataInStore) {
      setData(integrationModuleDataInStore);
    } else {
      fetchData(projectId);
    }
  }, [projectId, integrationModuleId]);

  return {
    integrationModuleData: data,
    loading,
    targetModule,
  };
}

export default useIntegrationModuleFinder;
